export const showOnePlz = (arr) => {
    if (arr.length !== 5) {
      return `${arr.slice(0, 5)}...`
    }
    return arr
  }